import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
const benefits = [{
  title: <>
        Durar <strong className="text-brand-gold" data-id="element-11">todo lo que quieras</strong>
      </>,
  desc: <>
        <span className="bg-brand-gold/10 px-1 rounded text-brand-gold font-medium" data-id="element-12">
          20 minutos, 1 hora
        </span>{' '}
        o el tiempo que vos elijas conscientemente
      </>
}, {
  title: <>
        Controlar tu excitación como un{' '}
        <strong className="text-white" data-id="element-13">maestro</strong>
      </>,
  desc: <>
        Usar{' '}
        <span className="underline decoration-brand-red/50 underline-offset-4" data-id="element-14">
          cualquier posición
        </span>{' '}
        sin miedo, Incluso las más intensas, rápidas y placenteras.
      </>
}, {
  title: <>
        Disfrutar del sexo oral{' '}
        <strong className="text-brand-red" data-id="element-15">sin ansiedad</strong>
      </>,
  desc: <>Sabiendo que tenés control total sobre tu respuesta</>
}, {
  title: <>
        Hacer que ella llegue{' '}
        <strong className="text-white" data-id="element-16">múltiples veces</strong>
      </>,
  desc: <>
        Ser el tipo que ella recuerda, No como "uno más", sino como{' '}
        <strong className="text-brand-gold" data-id="element-17">"el mejor que tuvo"</strong>
      </>
}, {
  title: <>
        Tener{' '}
        <strong className="text-brand-gold" data-id="element-18">confianza sexual absoluta</strong>
      </>,
  desc: <>Entrando a la cama sabiendo que dominás todo</>
}];
export function Benefits() {
  return <section className="py-16 px-4 bg-[#0a0a0a] relative" data-id="element-19">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-gold/5 rounded-full blur-[100px] -z-10 pointer-events-none" data-id="element-20" />

      <div className="max-w-5xl mx-auto" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-22">
          <span className="text-6xl mb-6 block" data-id="element-23">🚀</span>
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-24">
            Lo que vas a lograr con este método...
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-25">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-brand-card/50 p-6 rounded-xl border border-gray-800/50 hover:bg-brand-card transition-colors flex gap-4" data-id="element-26">
              <span className="text-2xl shrink-0" data-id="element-27">🔥</span>
              <div data-id="element-28">
                <h4 className="text-white font-bold text-lg mb-1" data-id="element-29">
                  {benefit.title}
                </h4>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-30">
                  {benefit.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-31">
          <p className="text-gray-400 uppercase tracking-widest text-sm mb-4" data-id="element-32">
            En resumen:
          </p>
          <h3 className="text-3xl md:text-5xl font-oswald text-white" data-id="element-33">
            Vas a pasar de ser el tipo que "aguanta"
            <br data-id="element-34" />
            <span className="text-brand-gold underline decoration-brand-gold/30 underline-offset-8" data-id="element-35">
              a ser el tipo que DOMINA.
            </span>
          </h3>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-36">
          <Button data-id="element-37">QUIERO EL MÉTODO</Button>
        </motion.div>
      </div>
    </section>;
}